import '../styles/tokens.css'
import '../styles/tickets.css'
import useViewportBleed from '../hooks/useViewportBleed'
import Hero from './Hero'
import TicketsCart from './TicketsCart'
import ExperienceRow from './ExperienceRow'
import StatsRow from './StatsRow'
import WelcomeBand from './WelcomeBand'

function App() {
	useViewportBleed()

	return (
		<div className='hx'>
			<Hero />
			<TicketsCart />
			<ExperienceRow />
			<StatsRow />
			<WelcomeBand />
		</div>
	)
}

export default App
